<div class="wrapper">
  <!-- top navbar-->
  <app-header class="topnavbar-wrapper"></app-header>
  <!-- sidebar-->
  <app-sidebar class="aside-container"></app-sidebar>
  <!-- offsidebar -->
  <app-offsidebar class="offsidebar"></app-offsidebar>
  <!-- Main section-->
  <section class="section-container" #sectionContainer>
    <!-- Page content-->
    <div class="content-wrapper">
      <app-content-header></app-content-header>
      <router-outlet></router-outlet>
    </div>
  </section>
  <!-- Page footer-->
  <footer *ngIf="showFooter" class="footer-container" app-footer></footer>
  <!-- <footer class="footer-container" app-footer></footer> -->
</div>
